import React, { PropTypes } from "react";
import update from "react-addons-update";
import { Button } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  change as changeFieldValue,
  Field,
  formValueSelector,
  reduxForm,
  SubmissionError,
} from "redux-form";
import * as dataActions from "../../../../../utils/data/dataActions";
import {
  CLIENTS_V2,
  FOLLOW_UP_ATTACHMENTS,
  FOLLOW_UP_COMMENTS,
} from "../../../../../utils/data/models";
import * as downloaderActions from "../../../../../utils/downloader/downloaderActions";
import validationUtils from "../../../../../utils/ValidationUtils";
import { BSModal, MessageBox, Render } from "../../../../common";
import { isAssociatedClientUserReadOnly } from "../../../../common/clientHelper";
import { autoAdjustFieldHeight } from "../../../../common/FieldHelper";
import {
  CheckboxInput,
  DayPicker,
  SelectInput,
  TextInput,
} from "../../../../common/form";
import { getTenantFromURL } from "../../../../common/MultiTenancy/MultiTenancyHelper";
import { isValidUrl } from "../../../../common/ParseLink";
import * as loginActions from "../../../../login/loginActions";
import { INITIATE_PASSWORD_RESET_FAILURE } from "../../../../login/loginActionTypes";
import { NoteFollowUp } from "./";
import FollowUpAttachments from "./attachments/FollowUpAttachments";
import FollowUpComments from "./comments/FollowUpComments";
import followUpPriorities, {
  MEDIUM,
  TWODAYS,
  URGENT,
} from "./enums//followUpPriorities";
import followUpOriginTypes, {
  EMAIL,
  MANUAL,
  PHONE,
} from "./enums/followUpOriginTypes";
import { CLOSED, NEW } from "./enums/followUpStatusTypes";
import followUpTypes, {
  INCIDENT,
  NOTE,
  PASSWORD_MANAGEMENT,
  SPECIAL_MODIFICATION,
} from "./enums/followUpTypes";
import incidentFollowUpCategories from "./enums/incidentFollowUpCategories";
import specialModificationCategories from "./enums/specialModificationCategories";
import { NOTE_VALIDATION_RULES } from "./noteValidationRules";


class BasicFollowUpFields extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      noteType: this.props.initialValues.followUpType,
      generateFollowUp: false,
      mandatoryFollowUp: false,
      followUpAttachments: null,
      downloadPath: null,
      disableDeadline:
        this.props.initialValues.priority == MEDIUM.value ? false : true,
      showPasswordModal: false,
      showResponseModal: false,
      disableConfirmButton: false,
      resultTitle: "",
      resultMessage: "",
    };

    this.getSubTypes = this.getSubTypes.bind(this);
    this.handleAttachmentDelete = this.handleAttachmentDelete.bind(this);
    this.handleAttachmentDownload = this.handleAttachmentDownload.bind(this);
    this.handleAttachmentDownloaded = this.handleAttachmentDownloaded.bind(
      this
    );
    this.handleUploadFinish = this.handleUploadFinish.bind(this);
    this.onFollowUpToggle = this.onFollowUpToggle.bind(this);
    this.onTypeSelect = this.onTypeSelect.bind(this);
    this.onPrioritySelect = this.onPrioritySelect.bind(this);
    this.calculateDeadline = this.calculateDeadline.bind(this);
    this.handlePasswordEmail = this.handlePasswordEmail.bind(this);
    this.closeWithConfirmation = this.closeWithConfirmation.bind(this);
    this.closeWithoutConfirmation = this.closeWithoutConfirmation.bind(this);
    this.closeResponseModal = this.closeResponseModal.bind(this);
    this.getComments = this.getComments.bind(this);
    this.parseStringForLinks = this.parseStringForLinks.bind(this);
    this.handleDescriptionChange = this.handleDescriptionChange.bind(this);
    this.isClientTerminatedForRelatedUser = this.isClientTerminatedForRelatedUser.bind(this);
    this.initializeDescriptionField = this.initializeDescriptionField.bind(this);
  }

  componentWillMount() {
    const { initialValues, dataActions, needsActiveProperty, add } = this.props;

    if (!!initialValues.followUpId) {
      dataActions
        .getDataList(
          FOLLOW_UP_ATTACHMENTS,
          0,
          0,
          "",
          ["createdAt:asc"],
          [`followUpAttachments.followUpId==${initialValues.followUpId}`],
          {},
          {},
          null,
          ""
        )
        .then((data) => {
          data.payload.data.forEach((attachment) => {
            attachment.objectPath.startsWith(`${getTenantFromURL()}/`) ?
              attachment.objectPath = attachment.objectPath.replace(`${getTenantFromURL()}/`, '') :
              attachment.objectPath;
          });
          this.setState({ followUpAttachments: data.payload.data });
        });
    }

    let clientsV2Filters = [];
    if (add) clientsV2Filters.push(CLIENTS_V2.archiveFilter);

    dataActions.getDataList(
      CLIENTS_V2,
      0,
      0,
      "",
      ["name:asc"],
      clientsV2Filters,
      {},
      {},
      "clientId,name",
      undefined,
      {},
      needsActiveProperty
    );
  }

  componentDidMount() {
    let deadline = this.props.initialValues.deadline ? this.props.initialValues.deadline : "N/D";
    if (this.props.initialValues.followUpStatusType === NEW.value) {
      deadline = this.calculateDeadline(this.props.initialValues.priority);
    }
    this.onTypeSelect(this.props.initialValues.followUpType);
    this.props.changeFieldValue("memberNote", "deadline", deadline);
    this.initializeDescriptionField();
  }

  componentDidUpdate() {
    if (this.props.shortLivedURL) {
      if (this.props.successDownloads.length > 0) {
        let finishedDownloadObj = this.props.successDownloads.find(
          (download) => download.path == this.props.shortLivedURL
        );

        if (finishedDownloadObj) {
          this.handleAttachmentDownloaded();
        }
      }
      if (this.props.errorDownloads.length > 0) {
        let finishedDownloadObj = this.props.errorDownloads.find(
          (download) => download.path == this.props.shortLivedURL
        );

        if (finishedDownloadObj) {
          this.handleAttachmentDownloaded();
        }
      }
    }
  }

  handleAttachmentDelete(deletedFile, e) {
    e.stopPropagation();
    const objectIndex = this.state.followUpAttachments.findIndex(
      (item) => item.objectName === deletedFile.objectName
    );
    this.setState(
      {
        followUpAttachments: update(this.state.followUpAttachments, {
          $splice: [[objectIndex, 1]],
        }),
      },
      () =>
        this.props.changeFieldValue(
          "memberNote",
          "followUpAttachments",
          this.state.followUpAttachments
        )
    );
  }

  handleDescriptionChange(e) {
    const text = e.target.value;
    autoAdjustFieldHeight(e, text, "description");
  }

  initializeDescriptionField() {
    const { initialValues } = this.props;

    const nameFields = document.getElementsByName("description");

    if (nameFields && initialValues.description && initialValues.description.length > 0) {
      const nameField = nameFields[0];
      nameField.style.height = nameField.scrollHeight + "px";
    }
  }

  handleUploadFinish(uploadedFile) {
    this.setState(
      {
        followUpAttachments: update(
          !!this.state.followUpAttachments
            ? this.state.followUpAttachments
            : [],
          {
            $push: [{ ...uploadedFile, status: "UPLOADED" }],
          }
        ),
      },
      () =>
        this.props.changeFieldValue(
          "memberNote",
          "followUpAttachments",
          this.state.followUpAttachments
        )
    );
  }

  handleAttachmentDownloaded() {
    this.props.dataActions.clearS3DataFile(FOLLOW_UP_ATTACHMENTS);
  }

  handleAttachmentDownload(options) {

    if (options.objectPath.startsWith(`${getTenantFromURL()}/`)) {
      options.objectPath = options.objectPath.replace(`${getTenantFromURL()}/`, '');
    }
    const query = {
      clientMethod: "get_object",
      objectPath: options.objectPath,
      objectName: options.objectName,
      regionName: options.regionName,
      bucketName: options.bucketName,
    };
    return this.props.dataActions
      .getS3DataFile(
        { ...FOLLOW_UP_ATTACHMENTS, path: FOLLOW_UP_ATTACHMENTS.signingPath },
        "",
        query,
        null
      )
      .then((result) => {
        if (result.payload.error) {
          throw new SubmissionError({
            _error: result.payload.error.data.error,
          });
        }
      });
  }

  parseStringForLinks(string) {
    const delimiters = /[\n\0\t ]+/g;
    let list = string.split(delimiters);

    return (
      <div className="form-group">
        <label className="control-label">
          <span><FormattedMessage id="members.followUps.form.associatedLinks" /></span>
        </label>
        <div className="input-wrapper">
          {list.map(word => {
            return isValidUrl(word) ? (<span><a href={word} target="_blank">{word}</a><br /></span>) : null;
          })}</div>
      </div>);
  }

  getSubTypes(type) {
    switch (type) {
      case INCIDENT.value:
        return incidentFollowUpCategories;

      case SPECIAL_MODIFICATION.value:
        return specialModificationCategories;

      default:
        return null;
    }
  }

  onFollowUpToggle(value) {
    this.setState({ generateFollowUp: value });
    return value;
  }

  handlePasswordEmail() {
    this.setState({
      showPasswordModal: true,
    });
  }

  getComments() {
    const { dataActions, initialValues } = this.props;
    const sortBy = ["createdAt:desc"];
    const filters = [`followUpComments.followUpId==${initialValues.followUpId}`];

    dataActions.getPagelessDataList(
      FOLLOW_UP_COMMENTS,
      0,
      0,
      "",
      sortBy,
      filters,
      {},
      {},
      null,
      "FOLLOW_UP_COMMENTS"
    );
  }

  closeWithConfirmation() {
    this.setState({ disableConfirmButton: true });
    const { emailAddress, username } = this.props.initialValues.relatedUser;
    const userData = {
      emailAddress,
      username,
    };
    let resultStatus = null;
    this.props.loginActions.initiatePasswordReset(userData).then((data) => {
      if (data.type == INITIATE_PASSWORD_RESET_FAILURE)
        resultStatus = "failure";
      else {
        resultStatus = "success";
        this.getComments();
      }
      this.setState({
        showPasswordModal: false,
        disableConfirmButton: false,
        resultTitle: `members.followUps.form.emails.${resultStatus}.resultTitle`,
        resultMessage: `members.followUps.form.emails.${resultStatus}.resultMessage`,
        showResponseModal: true,
      });
    });
  }

  closeWithoutConfirmation() {
    this.setState({
      showPasswordModal: false,
    });
  }

  closeResponseModal() {
    this.setState({
      showResponseModal: false,
    });
  }

  onTypeSelect(value) {
    switch (value) {
      case INCIDENT.value:
        if (value == this.props.initialValues.followUpType)
          this.props.changeFieldValue("memberNote", "subType", this.props.initialValues.incidentType);
        else {
          this.props.changeFieldValue("memberNote", "subType", null);
        }
        this.setState({ mandatoryFollowUp: true, generateFollowUp: true });
        this.props.changeFieldValue("memberNote", "generateFollowUp", true);
        break;
      case SPECIAL_MODIFICATION.value: {
        if (value == this.props.initialValues.followUpType)
          this.props.changeFieldValue("memberNote", "subType", this.props.initialValues.specialModificationType);
        else {
          this.props.changeFieldValue("memberNote", "subType", null);
        }
        this.setState({ mandatoryFollowUp: true, generateFollowUp: true });
        this.props.changeFieldValue("memberNote", "generateFollowUp", true);
        break;
      }
      default: {
        if (
          !(
            this.props.initialValues.memberId ||
            this.props.initialValues.clientId
          ) ||
          this.props.initialValues.generateFollowUp
        ) {
          this.setState({ mandatoryFollowUp: true, generateFollowUp: true });
        } else {
          this.setState({ mandatoryFollowUp: false });
        }
        break;
      }
    }

    this.setState({ noteType: value });
    return value;
  }

  onPrioritySelect(value) {
    this.props.changeFieldValue(
      "memberNote",
      "deadline",
      this.calculateDeadline(value)
    );
    this.setState({
      disableDeadline: value == MEDIUM.value ? false : true,
    });
    return value;
  }

  calculateDeadline(priority) {
    let date;
    let daysToAdd = 0;

    if (!priority) return null;

    switch (priority) {
      case URGENT.value:
        daysToAdd = 1;
        break;
      case TWODAYS.value:
        daysToAdd = 2;
        break;
      case MEDIUM.value:
        daysToAdd = 4;
        break;
    }
    date = new Date(
      new Date().toLocaleString("en-US", {
        timeZone: "America/Montreal",
      })
    );
    date.setDate(date.getDate() + daysToAdd);

    return date;
  }

  isClientTerminatedForRelatedUser(relatedUser, client) {
    if (!relatedUser || (relatedUser.associatedClientId && (!client || !relatedUser))) {
      /** Client or relatedUser sometimes may be temporairly undefined due to component re-rendering. */
      return true;
    }
    return relatedUser && isAssociatedClientUserReadOnly(client);
  }

  render() {
    const {
      followUpStatusType,
      descriptionKey,
      followUpType,
      relatedUser,
      deadline,
      clientId
    } = this.props.initialValues;
    const { readOnly, add, type, priority, isArchivedMember, isArchivedClient } = this.props;
    const clients = this.props.clientList.map((client) => {
      return { value: client.clientId, text: client.name };
    });
    const client = this.props.clientList.find((c) => c.clientId == clientId);
    const isPasswordManagement = followUpType == PASSWORD_MANAGEMENT.value;
    let formattedValues = {};
    let displayedFollowUpTypes = followUpTypes;
    let dateType = "text";
    let dateComponent = TextInput;
    let dateProps = {};
    let showDate = (priority && followUpStatusType !== CLOSED.value) || deadline ? true : false;
    if (showDate) {
      dateType = "date";
      dateComponent = DayPicker;
      dateProps = {
        dateFormat: "YYYY/MM/DD",
        utc: false,
      };
    }
    if (!isPasswordManagement)
      displayedFollowUpTypes = displayedFollowUpTypes.filter(
        (type) => type.value != PASSWORD_MANAGEMENT.value
      );
    else
      formattedValues = {
        email: relatedUser.emailAddress,
        userFullName: `${relatedUser.firstName} ${relatedUser.lastName}`,
      };


    return (
      <div>
        {!this.props.isArchivedMember && (
          <div>
            <MessageBox className="alert-info">
              <FormattedMessage id="members.followUps.form.fileDepositWarning" />
            </MessageBox>
          </div>
        )}
        <form onSubmit={this.props.handleSubmit}>
          <div className="sub-group">
            {this.state.generateFollowUp && (
              <Field
                normalize={this.onPrioritySelect}
                id="priority"
                name="priority"
                component={SelectInput}
                options={followUpPriorities}
                sortOptions={false}
                disabled={followUpStatusType === "CLOSED" || readOnly}
                label={
                  <FormattedMessage id="members.followUps.form.priority" />
                }
              />
            )}
            <Field
              id="date"
              name="date"
              type="text"
              component={TextInput}
              isStatic={true}
              label={<FormattedMessage id="members.followUps.form.date" />}
            />
            {this.state.generateFollowUp && (
              <Field
                id="deadline"
                name="deadline"
                type={dateType}
                component={dateComponent}
                props={dateProps}
                disabled={
                  this.state.disableDeadline ||
                  followUpStatusType === "CLOSED" ||
                  readOnly
                }
                label={
                  <FormattedMessage id="members.followUps.form.deadline" />
                }
              />
            )}
            <Field id="userId" name="userId" component="input" type="hidden" />
            <Field
              id="user"
              name="user"
              type="text"
              component={TextInput}
              isStatic={true}
              label={<FormattedMessage id="members.followUps.form.user" />}
            />
            <Field
              normalize={this.onTypeSelect}
              id="followUpType"
              name="followUpType"
              component={SelectInput}
              options={displayedFollowUpTypes}
              sortOptions={false}
              disabled={
                followUpStatusType === "CLOSED" ||
                readOnly ||
                isPasswordManagement
              }
              label={<FormattedMessage id="members.followUps.form.type" />}
            />
            <Field
              id="followUpOriginType"
              name="followUpOriginType"
              component={SelectInput}
              options={
                this.props.add ? [MANUAL, PHONE, EMAIL] : followUpOriginTypes
              }
              sortOptions={false}
              disabled={
                !add || !!type || followUpStatusType === "CLOSED" || readOnly
              }
              label={<FormattedMessage id="members.followUps.form.origin" />}
            />
            {!readOnly && (
              <Field
                id="generateFollowUp"
                name="generateFollowUp"
                component={CheckboxInput}
                type="checkbox"
                disabled={this.state.mandatoryFollowUp}
                checkbox={{ value: true }}
                label={
                  <FormattedMessage id="members.followUps.form.generateFollowUp" />
                }
                normalize={this.onFollowUpToggle}
              />
            )}

            {![NOTE.value, PASSWORD_MANAGEMENT.value].includes(
              this.state.noteType
            ) && (
                <Field
                  id="subType"
                  name="subType"
                  component={SelectInput}
                  options={this.getSubTypes(this.state.noteType)}
                  addBlankOption={true}
                  required={true}
                  sortOptions={false}
                  disabled={followUpStatusType === "CLOSED" || readOnly}
                  label={<FormattedMessage id="members.followUps.form.subType" />}
                />
              )}
            <div id="hidden-div-description" />
            <Field
              id="description"
              name="description"
              type="textarea"
              componentClass="textarea"
              className="expandable-text-area"
              component={TextInput}
              required={true}
              onChange={this.handleDescriptionChange}
              disabled={
                followUpStatusType === "CLOSED" || readOnly || descriptionKey
              }
              label={
                <FormattedMessage id="members.followUps.form.description" />
              }
            />
            {this.parseStringForLinks(this.props.initialValues.description)}
            <div className="large-label dollar">
              <Field
                id="transactionAmount"
                name="transactionAmount"
                type="absNumber"
                component={TextInput}
                disabled={followUpStatusType === "CLOSED" || readOnly}
                label={
                  <FormattedMessage id="members.followUps.form.transactionAmount" />
                }
              />
            </div>
          </div>

          {this.state.generateFollowUp && (
            <div className="sub-group">
              <NoteFollowUp
                type={this.props.type}
                readOnly={readOnly}
                isEdit={!add}
                clientId={this.props.initialValues.clientId}
                clients={clients}
                members={this.props.memberList}
                memberId={this.props.initialValues.memberId}
                memberClientId={
                  this.props.initialValues.member &&
                  this.props.initialValues.member.clientId
                }
                followUpStatusType={this.props.initialValues.followUpStatusType}
                disabledFollowUpFields={
                  !!this.props.initialValues.memberId ||
                  !!this.props.initialValues.clientId
                }
                closedDescription={this.props.initialValues.closedDescription}
                closeFollowUp={this.props.closeFollowUp}
                needsActiveProperty={this.props.needsActiveProperty}
              />
            </div>
          )}
        </form>
        <div className="sub-group">
          <FollowUpAttachments
            followUpGuid={this.props.initialValues.followUpGuid}
            followUpAttachments={this.state.followUpAttachments}
            followUpId={this.props.initialValues.followUpId}
            readOnly={followUpStatusType === "CLOSED" || readOnly}
            shortLivedURL={this.props.shortLivedURL}
            handleAttachmentDownload={this.handleAttachmentDownload}
            handleAttachmentDownloaded={this.handleAttachmentDownloaded}
            handleAttachmentDelete={this.handleAttachmentDelete}
            handleUploadFinish={this.handleUploadFinish}
          />
          {!this.props.add && (
            <FollowUpComments
              userId={this.props.activeUserId}
              followUpId={this.props.initialValues.followUpId}
              generateFollowUp={!!this.props.generateFollowUp}
              reload={this.props.reload}
              getData={this.getComments}
              isArchivedMember={isArchivedMember}
              isArchivedClient={isArchivedClient}
            />
          )}
          <Render if={isPasswordManagement && followUpStatusType === "OPEN" && !relatedUser.isArchived}>
            <div className="follow-up-email-section button button-container right">
              <Button
                className="btn btn-lg btn-primary"
                onClick={this.handlePasswordEmail}
                disabled={this.isClientTerminatedForRelatedUser(relatedUser, client)}
              >
                <FormattedMessage id="members.followUps.form.emails.resend" />
              </Button>
            </div>
            <BSModal
              show={this.state.showPasswordModal}
              title={
                <FormattedMessage id="members.followUps.form.emails.sendEmailTitle" />
              }
              actions={[
                {
                  id: 1,
                  disabled: this.state.disableConfirmButton,
                  text: <FormattedMessage id="common.confirm" />,
                  action: this.closeWithConfirmation,
                },
              ]}
              onClose={this.closeWithoutConfirmation}
            >
              <FormattedMessage
                id="members.followUps.form.emails.sendEmailMessage"
                values={formattedValues}
              />
            </BSModal>
            <BSModal
              show={this.state.showResponseModal}
              title={<FormattedMessage id={this.state.resultTitle} />}
              onClose={this.closeResponseModal}
            >
              <FormattedMessage
                id={this.state.resultMessage}
                values={formattedValues}
              />
            </BSModal>
          </Render>
        </div>
      </div>
    );
  }
}

BasicFollowUpFields.propTypes = {
  activeUserId: PropTypes.number,
  add: PropTypes.bool,
  changeFieldValue: PropTypes.func,
  closeFollowUp: PropTypes.bool,
  dataActions: PropTypes.object,
  loginActions: PropTypes.object,
  generateFollowUp: PropTypes.bool,
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  readOnly: PropTypes.bool,
  reload: PropTypes.func,
  shortLivedURL: PropTypes.string,
  type: PropTypes.string,
  clientList: PropTypes.array,
  memberList: PropTypes.array,
  needsActiveProperty: PropTypes.bool,
  priority: PropTypes.string,
  readOnlyTermination: PropTypes.bool,
  isArchivedMember: PropTypes.bool,
  successDownloads: PropTypes.array,
  errorDownloads: PropTypes.array,
  isArchivedClient: PropTypes.bool,
  handleAttachmentDownloaded: PropTypes.func,
};

function mapStateToProps(state) {
  const selector = formValueSelector("memberNote");
  const file = state.data.followUpAttachments || { shortLivedURL: null };
  const downloads = state.downloader || {};
  const clients = state.data.clients || {};
  const members = state.data.members || {};
  return {
    activeUserId: state.auth.user.userId,
    generateFollowUp: selector(state, "generateFollowUp"),
    errorDownloads: downloads.errorDownloads || [],
    successDownloads: downloads.successDownloads || [],
    closeFollowUp: !!selector(state, "closeFollowUp"),
    shortLivedURL: !!file.shortLivedURL ? file.shortLivedURL.signedUrl : null,
    clientList: clients.items || [],
    memberList: members.items || [],
    priority: selector(state, "priority") || null
  };
}

function mapDispatchToProps(dispatch) {
  return {
    changeFieldValue: bindActionCreators(changeFieldValue, dispatch),
    dataActions: bindActionCreators(dataActions, dispatch),
    downloaderActions: bindActionCreators(downloaderActions, dispatch),
    loginActions: bindActionCreators(loginActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
  withRef: true,
})(
  reduxForm({
    form: "memberNote",
    validate: (values) =>
      validationUtils.validate(values, NOTE_VALIDATION_RULES),
  })(BasicFollowUpFields)
);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/notes/BasicFollowUpFields.js